/**
 * Вписывает изображение в доступную ширину, не ограничивая высоту.
 * Более узкие, чем контейнер, остаются в исходном размере;
 * более широкие уменьшаются до 100% доступной ширины.
 */
export function fitImageToAvailableWidth(original, availableWidth) {
  const width = Number(original && original.width) || 0;
  const height = Number(original && original.height) || 0;
  const maxWidth = Number(availableWidth) || 0;

  if (width <= 0 || height <= 0 || maxWidth <= 0) {
    return { width: 0, height: 0 };
  }

  if (width <= maxWidth) {
    return { width, height };
  }

  const scale = maxWidth / width;
  return {
    width: maxWidth,
    height: height * scale,
  };
}
